import React, { useEffect, useState } from "react";

//custom
import moment from "moment";
import DatePicker from "react-datepicker";
//import axios
import axios from "axios";

//utils
import {
  check_authorized,
  signoutuser_confirm,
  isloginuser,
  get_userseckey,
  getuniquedeviceid,
  signoutuser,
} from "../../utils/Helper/CheckAuth";
import CallURL from "../../utils/API/CallURL";
import {
  showLoading,
  stopLoading,
  showLoadingPercentage,
  sent_clean_var,
  onlynumber,
  fun_input_focus,
} from "../../utils/Helper/JSHelper";

function ContentCard(props) {
  //props
  const { topic_id, afteradd, edit_add, is_admin, item_info } = props;

  //const variable
  const [content_id, set_content_id] = useState(
    edit_add == "edit" ? item_info.content_id : ""
  );
  const [content_seq, set_content_seq] = useState(
    edit_add == "edit" ? item_info.content_seq : ""
  );
  const [content_text, set_content_text] = useState(
    edit_add == "edit" ? item_info.content_text : ""
  );
  const [content_sts, set_content_sts] = useState(
    edit_add == "edit" ? item_info.content_sts : ""
  );
  const [updatetime, set_updatetime] = useState(
    edit_add == "edit" ? item_info.updatetime : ""
  );
  const [entrytime, set_entrytime] = useState(
    edit_add == "edit" ? item_info.entrytime : ""
  );

  //html file vareiable
  const [selectedFile, setselectedFile] = useState(null);
  const [selectedResult, setselectedResult] = useState(null);

  //extra variable
  const [is_edit_show, set_is_edit_show] = useState(false);

  //action on user card
  //add item
  function add_edit_item() {
    if (content_seq == "") {
      alert("Enter Content Sequence");
      fun_input_focus(content_id + "frm_content_seq");
    } else if (selectedFile == null || selectedResult == null) {
      alert("Select Content HTML File");
    } else {
      //showLoading
      showLoading();
      // Create an object of formData
      const formData = new Object();
      // Update the formData object
      formData.secuserkey = get_userseckey();
      formData.deviceid = getuniquedeviceid();
      //extra variable
      formData.topic_id = topic_id;
      formData.edit_add = edit_add;
      formData.content_id = content_id;
      formData.content_seq = content_seq;
      formData.content_file = selectedFile;
      // Send formData object
      axios
        .post(CallURL.add_edit_content, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            //do what you need here
            showLoadingPercentage(
              parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              )
            );
          },
        })
        .then((response) => {
          //stopLoading
          stopLoading();
          //console.log(response);
          //alert(response.data.apires);
          if (response.data.apires == "unauthorized") {
            //make logout
            signoutuser();
          } else if (response.data.apires == "success") {
            if (edit_add == "add") {
              afteradd();
              //reset data
              set_content_seq("");
              set_content_text("");
              //reset html file value
              reset_html_file_state();
              //reset browse file selected file value
              document.getElementById("html_file_browse").value = "";
            } else if (edit_add == "edit") {
              load_item();
              set_is_edit_show(false);
            }
          } else if (response.data.apires == "duplicate") {
            alert("This Content name already present.");
          } else {
            alert("Something went wrong. Try again.");
          }
        })
        .catch((error) => {
          //stopLoading
          stopLoading();
          console.log(error);
          alert("Something went wrong. Try again.");
        });
    }
  }
  //load_content
  function load_item() {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    //extra authorized user
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    //extra variable
    formData.content_id = content_id;
    // Send formData object
    axios
      .post(CallURL.load_content, formData)
      .then((response) => {
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "success") {
          //set item
          var rows = response.data.rows[0];
          set_content_id(rows.content_id);
          set_content_seq(rows.content_seq);
          set_content_text(rows.content_text);
          set_content_sts(rows.content_sts);
          set_updatetime(rows.updatetime);
          set_entrytime(rows.entrytime);
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        stopLoading();
        alert("Something went wrong. Try again.");
      });
  }
  //change_status
  function change_status(status) {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    //extra variable
    formData.content_id = content_id;
    formData.status = status;
    // Send formData object
    axios
      .post(CallURL.edit_content_status, formData)
      .then((response) => {
        //stopLoading
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "unauthorized") {
          //make logout
          signoutuser();
        } else if (response.data.apires == "success") {
          load_item();
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        //stopLoading
        stopLoading();
        console.log(error);
        alert("Something went wrong. Try again.");
      });
  }

  //validate data
  function handle_enter_sequence(e) {
    if (onlynumber(e, 3)) {
      set_content_seq((content_seq) => e.target.value);
    }
  }

  // On file select (from the pop up)
  function onFileChange(event) {
    var fileName = event.target.value;
    var ext = fileName.substring(fileName.lastIndexOf(".") + 1);
    var iserroselect = false;
    if (ext == "HTML" || ext == "html") {
      //width and height and size validate of image
      if (event.target.files && event.target.files[0]) {
        var s = ~~(event.target.files[0].size / 1024);
        if (s > 5 && s < 20480) {
          //file validate
        } else {
          iserroselect = true;
          event.target.value = "";
          alert("Size of selected image greater than 20MB.");
        }
      } else {
        iserroselect = true;
        event.target.value = "";
        alert("Select HTML file only");
      }
    } else {
      iserroselect = true;
      event.target.value = "";
      alert("Select HTML file only");
    }
    //set file validation result
    if (!iserroselect) {
      // Update the state
      setselectedFile((selectedFile) => event.target.files[0]);
      //read image file and set to selectedResult
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = function (e) {
        setselectedResult((selectedResult) => e.target.result);
      };
    } else {
      reset_html_file_state();
    }
  }
  function reset_html_file_state() {
    setselectedFile((selectedFile) => null);
    setselectedResult((selectedResult) => null);
  }

  return (
    <>
      {(() => {
        const return_text_card = [];
        if (
          (edit_add == "add" && is_admin == "yes") ||
          (is_edit_show && edit_add == "edit" && is_admin == "yes")
        ) {
          return_text_card.push(
            <div className="div_item z-depth-0">
              Content Sequence
              <input
                type="text"
                placeholder="Content Sequence"
                id={content_id + "frm_content_seq"}
                name={content_id + "frm_content_seq"}
                value={content_seq}
                onChange={(e) => {
                  handle_enter_sequence(e);
                }}
                autoComplete="off"
              />
              Content HTML File
              <br />
              <input
                id="html_file_browse"
                accept=".HTML"
                type="file"
                name="html_file_browse"
                onChange={onFileChange}
              />
              <br />
              <br />
              <a
                className="btn green"
                style={{ width: edit_add == "add" ? "100%" : "50%" }}
                onClick={add_edit_item}
              >
                <b>{edit_add == "add" ? "Add" : "Save"} Content</b>
              </a>
              {edit_add == "edit" ? (
                <a
                  className="btn red"
                  style={{ width: "50%" }}
                  onClick={() => {
                    load_item();
                    set_is_edit_show(false);
                  }}
                >
                  <b>Close</b>
                </a>
              ) : (
                ""
              )}
            </div>
          );
        }
        if (edit_add == "edit" && !is_edit_show) {
          return_text_card.push(
            <div>
              <div className="center">
                {(() => {
                  const return_text = [];
                  if (is_admin == "yes") {
                    return_text.push(
                      <font
                        className="font_sub_small_content_card"
                        style={{
                          color: "black",
                          backgroundColor: "#ffffff",
                          cursor: "pointer",
                        }}
                        onClick={() => set_is_edit_show(true)}
                      >
                        <hr />
                        &nbsp;
                        <i className="fa fa-pencil fa-lg" /> Edit Content <br />
                      </font>
                    );
                    if (content_sts == "1") {
                      return_text.push(
                        <font
                          className="font_sub_small_content_card"
                          style={{ color: "green", backgroundColor: "#ffffff" }}
                        >
                          <i className="fa fa-check fa-lg" /> Active Content{" "}
                          <a
                            className="btn-floating z-depth-1 red"
                            onClick={() => change_status("0")}
                            style={{ zIndex: "0" }}
                          >
                            <i className="fa fa-close"></i>
                          </a>
                        </font>
                      );
                    }
                    if (content_sts == "0") {
                      return_text.push(
                        <font
                          className="font_sub_small_content_card"
                          style={{ color: "red", backgroundColor: "#ffffff" }}
                        >
                          <i className="fa fa-close fa-lg" /> Deactivated
                          Content{" "}
                          <a
                            className="btn-floating z-depth-1 green"
                            onClick={() => change_status("1")}
                            style={{ zIndex: "0" }}
                          >
                            <i className="fa fa-check"></i>
                          </a>
                        </font>
                      );
                    }
                  }
                  return return_text;
                })()}
              </div>
              <div className="div_item_remove z-depth-0">
                {/*<font className="font_sub_title_content_card_18">
                  {content_seq}
                </font>
                <br />*/}
                <div
                  className=""
                  dangerouslySetInnerHTML={{ __html: content_text }}
                ></div>
              </div>
            </div>
          );
        }
        return return_text_card;
      })()}
    </>
  );
}

export default ContentCard;
